<template>
    <div class="exam-result-management">
        <h3> 계정관리 > 메뉴 관리</h3>
        <div class="account-card-box">
            <!-- 액션 버튼 -->
            <div class="account-btns-action">
                <button class="account-btn" @click="openMenuModal()">
                    새 메뉴 추가
                </button>
                <button class="account-btn btn-edit" @click="saveOrder">
                    순서 저장
                </button>
            </div>

            <!-- 메뉴 테이블 -->
            <table class="account-list-table">
                <colgroup>
                    <col style="width: 10%;">
                    <col style="width: auto;">
                    <col style="width: 10%;">
                    <col style="width: 10%;">
                    <col style="width: 20%;">
                </colgroup>
                <thead>
                    <tr>
                        <th>순서</th>
                        <th>메뉴명</th>
                        <th>깊이</th>
                        <th>사용 여부</th>
                        <th>관리</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="menu in menuData" :key="menu.menu_id">
                        <!-- 1단계 메뉴 -->
                        <tr class="menu-row" :class="{ expanded: menu.isExpanded }" @click="toggleMenu(menu.menu_id)">
                            <td>
                                <span>{{ menu.sort_ord }}</span>
                            </td>
                            <td>
                                <!-- 하위 메뉴가 있거나 확장된 상태일 때만 확장 버튼 표시 -->
                                <button v-if="(menu.children && menu.children.length > 0) || menu.isExpanded" 
                                    class="expand-btn" :class="{ expanded: menu.isExpanded }" 
                                    @click.stop="toggleMenu(menu.menu_id)">
                                    ▶
                                </button>
                                <span>{{ menu.menu_name }}</span>
                            </td>
                            <td>1단계</td>
                            <td>{{ menu.use_yn == 'Y' ? '✅' : '❌' }}</td>
                            <td>
                                <div class="action-buttons">
                                    <button class="btn-small btn-add" @click.stop="openMenuModal(menu)"
                                        title="하위 메뉴 추가">
                                        추가
                                    </button>
                                    <button class="btn-small btn-edit" @click.stop="openMenuModal(menu, 'edit')" title="수정">
                                        수정
                                    </button>
                                    <button class="btn-small btn-delete" @click.stop="deleteMenu(menu)" title="삭제">
                                        삭제
                                    </button>
                                </div>
                            </td>
                        </tr>

                        <!-- 2단계 메뉴 -->
                        <template v-if="menu.isExpanded">
                            <!-- 하위 메뉴가 있는 경우 -->
                            <template v-if="menu.children && menu.children.length > 0">
                                <template v-for="child in menu.children" :key="child.menu_id">
                                    <tr class="menu-row child-menu" :class="{ expanded: child.isExpanded }"
                                        @click="toggleMenu(child.menu_id)">
                                        <td>
                                            <span>{{ child.sort_ord }}</span>
                                        </td>
                                        <td>
                                            <!-- 하위 메뉴가 있거나 확장된 상태일 때만 확장 버튼 표시 -->
                                            <button v-if="(child.children && child.children.length > 0) || child.isExpanded" 
                                                class="expand-btn" :class="{ expanded: child.isExpanded }" 
                                                @click.stop="toggleMenu(child.menu_id)">
                                                ▶
                                            </button>
                                            <span>{{ child.menu_name }}</span>
                                        </td>
                                        <td>2단계</td>
                                        <td>{{ child.use_yn == 'Y' ? '✅' : '❌' }}</td>
                                        <td>
                                            <div class="action-buttons">
                                                <button class="btn-small btn-add" @click.stop="openMenuModal(child)"
                                                    title="하위 메뉴 추가">
                                                    추가
                                                </button>
                                                <button class="btn-small btn-edit" @click.stop="openMenuModal(child, 'edit')" title="수정">
                                                    수정
                                                </button>
                                                <button class="btn-small btn-delete" @click.stop="deleteMenu(child)" title="삭제">
                                                    삭제
                                                </button>
                                            </div>
                                        </td>
                                    </tr>

                                    <!-- 3단계 메뉴 -->
                                    <template v-if="child.isExpanded && child.children">
                                        <tr v-for="grandChild in child.children" :key="grandChild.menu_id"
                                            class="menu-row grandchild-menu">
                                            <td>
                                                <span>{{ grandChild.sort_ord }}</span>
                                            </td>
                                            <td>
                                                <span>{{ grandChild.menu_name }}</span>
                                            </td>
                                            <td>3단계</td>
                                            <td>{{ grandChild.use_yn == 'Y' ? '✅' : '❌' }}</td>
                                            <td>
                                                <div class="action-buttons">
                                                    <button class="btn-small btn-edit" @click.stop="openMenuModal(grandChild, 'edit')" title="수정">
                                                        수정
                                                    </button>
                                                    <button class="btn-small btn-delete" @click.stop="deleteMenu(grandChild)" title="삭제">
                                                        삭제
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    </template>
                                </template>
                            </template>
                            
                            <!-- 하위 메뉴가 없는 경우 빈 영역 표시 -->
                            <template v-else>
                                <tr class="menu-row empty-child">
                                    <td colspan="4" class="empty-message">
                                        하위 메뉴가 없습니다. '하위 메뉴 추가' 버튼을 클릭하여 메뉴를 추가하세요.
                                    </td>
                                </tr>
                            </template>
                        </template>
                    </template>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import api, {urls} from '@/api'
import { convertUtils } from '@/utils/convertUtils'
import { useModal } from '@/composables/useModal'
import { ref, onMounted } from 'vue'


const { openModal, setModalData, onModalEvent } = useModal()

export default {
    setup() {
        const menuData = ref([])
        const orgData = ref([])

        onMounted(() => {
            getList()
        })

        const getList = () => {
            api.get(urls.menu.list)
                .then(res => {
                    const list = res.data
                    orgData.value = list
                    menuData.value = convertUtils.buildMenuTree(list)
                })
        }

        // 메뉴 토글
        const toggleMenu = (menuId) => {
            const updateMenuExpansion = (menus, targetId) => {
                for (let menu of menus) {
                    if (menu.menu_id === targetId) {
                        menu.isExpanded = !menu.isExpanded
                        return true
                    }
                    if (menu.children && updateMenuExpansion(menu.children, targetId)) {
                        return true
                    }
                }
                return false
            }
            updateMenuExpansion(menuData.value, menuId)
        }

        // 모달 열기
        const openMenuModal = (menu = null, type = 'add') => {
            const modalName = 'menuModal'
            openModal(modalName)
            const data = {
                selectedMenu: menu,
                mode: type,
                menuData: menuData.value
            }
            setModalData(modalName, data)
            onModalEvent(modalName, 'onSubmit', () => {
                getList()
            })
        }

        // 메뉴 삭제
        const deleteMenu = (menu) => {
            if (confirm(`'${menu.menu_name}' 메뉴를 삭제하시겠습니까?`)) {
                api.post(urls.menu.delete, {
                    menuId: menu.menu_id
                }).then(res => {
                    if(res.data.result == 'success'){
                        alert('메뉴가 삭제되었습니다.')
                    }else{
                        alert('오류가 발생하였습니다.')
                    }
                    getList()
                })
            }
        }

        // 순서 저장
        const saveOrder = () => {
            const orderData = []
            
            const collectOrderData = (menus) => {
                menus.forEach(menu => {
                    orderData.push({
                        menu_id: menu.menu_id,
                        sort_ord: menu.sort_ord
                    })
                    if (menu.children && menu.children.length > 0) {
                        collectOrderData(menu.children)
                    }
                })
            }
            
            collectOrderData(menuData.value)
            
            api.post('/api/menu/updateOrder', {
                orderData: orderData
            }).then(res => {
                alert('메뉴 순서가 저장되었습니다.')
            })
        }

        return {
            menuData,
            toggleMenu,
            openMenuModal,
            deleteMenu,
            saveOrder
        }
    }
}
</script>

<style scoped>
/* 메뉴 리스트 테이블 */
.menu-row {
    cursor: pointer;
    transition: background-color 0.2s;
}

.menu-row:hover td {
    background-color: #eef6ff !important;
}

.menu-row.expanded td {
    background-color: #e8f4ff !important;
}

.expand-btn {
    background: none;
    border: none;
    cursor: pointer;
    color: #2094e8;
    font-size: 14px;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.2s;
}

.expand-btn.expanded {
    transform: rotate(90deg);
}

.child-menu {
    background-color: #f8fafe !important;
}

.child-menu {
    transform: scale(0.95);
    transform-origin: right center;
    background-color: #f8f9fa !important;
}

.child-menu td {
    background-color: #f8f9fa !important;
    padding: 8px 12px;
    border-top: 2px solid white;
    border-bottom: 2px solid white;
}

.grandchild-menu {
    background-color: #f0f8ff !important;
}

.grandchild-menu {
    transform: scale(0.9);
    transform-origin: right center;
    background-color: #e9ecef !important;
}

.grandchild-menu td {
    background-color: #e9ecef !important;
    padding: 6px 12px;
    border-top: 2px solid white;
    border-bottom: 2px solid white;
}

.action-buttons {
    display: flex;
    gap: 4px;
    justify-content: center;
}

.btn-add {
   background-color: #2094e8;
   color: #fff;
}

.btn-edit {
   background-color: #f0f8ff;
   color: #4a90e2;
   border: 1px solid #c3d9f1;
}

.btn-delete {
   background-color: #7e8489;
   color: #fff;
}

.order-input {
    width: 60px;
    padding: 4px 8px;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    text-align: center;
}

.empty-child {
    background-color: #f8fafe !important;
}

.empty-message {
    text-align: center;
    color: #999;
    font-style: italic;
    padding: 20px;
}
</style>